import getPreparationOrderStatusText from 'modules/get-preparation-order-status-text/get-preparation-order-status-text';
import { buildAgencyNamesString } from 'modules/build-agency-names-string/build-agency-names-string';
import getCarrierName from 'modules/get-carrier-name/get-carrier-name';

export function messagesES({ type = '', payload = {}, msg = '' }) {
  const preparationOrder = {
    'preparation_order.not_found': () => 'La orden de preparación no existe',
    'preparation_order.no_stock_user_can_not_pick': () =>
      'No puede preparar a la orden porque está en estado "Esperando traspaso"',
    'preparation_order.picked_by_another_user': () =>
      'Esta orden de preparación está siendo preparada por otro usuario',
    'preparation_order.invalid_status_change': ({ destination, origin }) =>
      `No puede cambiar la orden a estado ${getPreparationOrderStatusText(
        destination,
      )} porque está en ${getPreparationOrderStatusText(origin)}`,
    'preparation_order.user_can_not_force_close': () =>
      'No puede cerrar la orden de preparación porque aún hay etiquetas pendientes de imprimir',
    'preparation_order.bad_request': () =>
      'Petición incorrecta. Debe especificarse el id o referencia de la orden de preparación',
    'preparation_order.set_as_picking': () =>
      `El estado de la orden de preparación ha cambiado a "Continuar preparando"`,
    'preparation_order.set_as_transfer': () =>
      `El estado de la orden de preparación ha cambiado a "Pendiente de Traspaso"`,
    'preparation_order.set_as_closed': () =>
      `El estado de la orden de preparación ha cambiado a "Cerrada"`,
    'preparation_order.blocked_labels_can_not_force_close': () =>
      `La orden de preparación no puede cerrarse porque hay etiquetas bloqueadas`,
    'preparation_order.pending_another_agency': ({ agencies }) =>
      `Existen envíos por paletizar de ${buildAgencyNamesString(
        agencies,
      )}. Por favor, selecciona una Orden de Preparación de la misma agencia o paletiza lo pendiente.`,
    'preparation_order.invalid_warehouse': () => `El almacén no existe`,
    'preparation_order.distinct_agencies': () =>
      `Las órdenes de preparación seleccionadas pertenecen a agencias diferentes`,
    'preparation_order.pending_shipments_to_palletize': ({ prep_order }) =>
      `La orden de preparación ${prep_order} tiene envíos pendientes de paletizar`,
    'preparation_order.invalid_warehouse_group': () =>
      `El almacén seleccionado no pertenece al grupo del usuario`,
    'preparation_order.is_not_from_marketplace': () =>
      `No puede continuar porque la orden de preparación no es de marketplace`,
    'preparation_order.change_articles_group_not_allowed': () =>
      `No puede realizar cambios en artículos porque la orden de preparación no pertenece a un grupo que permita cambiar artículos`,
    'preparation_order.invalid_article_change': ({
      original,
      new: substitute,
    }) =>
      `No se ha podido sustituir el artículo ${original} por el ${substitute} porque no existe`,
    'preparation_order.invalid_article_change_label_not_found': ({
      original,
      new: newSKU,
    }) =>
      `No es posible cambiar el artículo ${original} por el ${newSKU} porque el paquete no tiene una etiqueta válida`,
  };

  const shipmentLabel = {
    'shipment_label.user_can_not_reprint_labels': () =>
      'La etiqueta ya está impresa',
    'shipment_label.unavailable_label': () =>
      'No puede obtenerse el contenido de la etiqueta',
    'shipment_label.label_does_not_exists': () =>
      'No puede obtenerse la etiqueta',
    'shipment_label.shipment_not_found': ({ shipment }) =>
      `La referencia de envío ${shipment} no existe`,
    'shipment_label.not_found': () => 'La etiqueta no existe',
    'shipment_label.shipment_has_no_labels': ({ shipment }) =>
      `El envío <strong>${shipment}</strong> no existe o no dispone de etiquetas`,
  };

  const manifest = {
    'manifest.preparation_order_not_found': () =>
      'La orden de preparación no existe',
    'manifest.invalid_preparation_order': ({ status }) =>
      `No puede generarse el manifiesto porque la orden de preparación está en estado: ${getPreparationOrderStatusText(
        status,
      )}`,
    'manifest.no_shipments_to_manifest': () =>
      `La orden de preparación no tiene envíos disponibles que manifestar`,
    'manifest.can_not_generate': () =>
      'No puede generar el manifiesto debido a que las referencias ya han sido manifestadas',
    'manifest.invalid_agency': ({ agency_code }) =>
      `No puede generar el manifiesto. La agencia <strong>${getCarrierName(
        agency_code,
      )}</strong> no existe`,
  };

  const shipment = {
    'shipment.not_found': () => `El envío no existe`,
    'shipment.can_not_retry_shipment': () => 'El envío no puede reintentarse',
    'shipment.can_not_delete_shipment': ({ shipment }) =>
      `No puede borrarse el envío ${shipment}`,
  };

  const auth = {
    'auth.apikey_invalid': () => 'Clave de API Inválida',
    'auth.user_can_not_register_shipments': () =>
      'El usuario no tiene permisos para registrar envíos',
    'auth.user_can_not_create_working_orders': () =>
      'El usuario no puede crear órdenes de trabajo',
    'auth.user_can_not_create_preparation_orders': () =>
      'El usuario no puede crear órdenes de preparación',
    'auth.user_is_not_admin': () =>
      'El usuario no tiene permisos de administración de la aplicación',
    'auth.user_is_not_staff': () =>
      'El usuario no tiene permisos de gestión (staff)',
    'auth.user_is_not_manager': () =>
      'El usuario no tiene permisos de administración',
    'auth.user_can_not_print_labels': () =>
      'El usuario no puede imprimir etiquetas',
    'auth.user_is_not_marketplace_stock_manager': () =>
      `El usuario no es manager de stock de marketplace`,
    'auth.user_can_not_change_articles': () =>
      `El usuario no tiene permiso para cambiar artículos`,
  };

  const pallet = {
    'pallets.invalid_pallet': () =>
      `No ha sido posible generar la etiqueta de pallet por tratarse de un pallet inválido`,
    'pallet.can_not_generate_label': () =>
      `No ha sido posible generar la etiqueta de pallet`,
  };

  const user = {
    'user.no_warehouse_set': () =>
      `El usuario no tiene configurado un almacén de trabajo. Por favor, contacta con tu superior`,
    'user.undefined_workstation': () =>
      'No se ha podido obtener el identificador de máquina. Por favor, ponte en contacto con soporte informático',
    'user.warehouse_not_found': () => `El almacén no existe`,
    'user.invalid_warehouse': () =>
      `El almacén seleccionado no pertenece al grupo del usuario`,
    'user.marketplace_not_found': () => `Los marketplaces no existen`,
    'user.invalid_marketplace': () =>
      `Los marketplaces seleccionados no pertenecen al grupo del user`,
  };

  const dsv = {
    'dsv.retrieve_orders_error': () =>
      `Error recuperando el listado de reintentos`,
    'dsv.retry_order_failed': () => `Error reintentando un pedido`,
    'dsv.cancel_order_failed': () => `Error cancelando un reintento`,
  };

  const pim = {
    'pim.not_found': ({ key, value }) =>
      `No se encuentra el artículo ${key}=${value}`,
  };

  const externalLabel = {
    'external_label.not_found': () => `La etiqueta externa no existe`,
  };

  const messages = {
    ...preparationOrder,
    ...shipmentLabel,
    ...manifest,
    ...shipment,
    ...auth,
    ...pallet,
    ...user,
    ...dsv,
    ...pim,
    ...externalLabel,
  };

  return type && messages[type] ? messages[type](payload) : msg;
}
